/**
 * Copy link button handler
 */

(function () {

    document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-copy-link]');
        if (!btn) return;
        e.preventDefault();
        var path = btn.getAttribute('data-copy-link');
        var url = window.location.origin + path;
        navigator.clipboard.writeText(url);
        var icon = btn.querySelector('i');
        icon.className = 'fa-solid fa-check';
        setTimeout(function () { icon.className = 'fa-solid fa-link'; }, 1500);
    });

})();
